module.exports = __webpack_public_path__ + "img/yapikredi.a8db41b2.png";